import { useSignIn } from '@/hooks/useSignIn';
import { useAuth } from '@/store/auth';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';
import { Spinner } from '../spinner';

export default function SplashScreen() {
    const sigin = useSignIn();
    const [loading] = useAuth(useShallow((state) => [state.loading]));
    const { t } = useTranslation();

    useEffect(() => {
        const id = setTimeout(() => {
            sigin();
        }, 500);

        return () => clearTimeout(id);
    }, [sigin]);

    return (
        <div className="h-dvh w-dvw overscroll-none flex flex-col relative bg-white items-center justify-center">
            <div className="pb-10 flex items-center justify-center flex-col">
                <img src="/splash.png" className="w-64" />
                <p
                    className="font-semibold text-4xl -mt-7 w-72 text-center"
                    style={{
                        background:
                            '#111 -webkit-linear-gradient(left, #111, #fff) no-repeat 0 0 / 30px text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'rgba(255,255,255,0.1)',
                        animation: 'sweep 2.5s ease-in infinite',
                    }}
                >
                    DeFutures
                </p>
            </div>
            <button
                disabled={loading}
                onClick={sigin}
                data-action="sign-in"
                className="flex items-center justify-center absolute left-5 right-5 bottom-5 z-20 text-base text-white font-medium h-14 px-4 rounded-full bg-black  disabled:opacity-50 "
            >
                {loading ? <Spinner /> : t('Sign in')}
            </button>
        </div>
    );
}
